


import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import AIReportProgressBanner from "./AIReportProgressBanner";
import { APP_ROUTES } from "../PageRouting/AppRoutes";

const GlobalAIReportProgressBanner = () => {
  const [quantumLoading, setQuantumLoading] = useState(false);
  const [quantumPercent, setQuantumPercent] = useState(0);
  const navigate = useNavigate();
  const bannerRef = useRef(null);

  useEffect(() => {
    // Pure read-only polling — globalUploader.js owns the full upload pipeline
    // including the check-uploaded-files call. This banner ONLY reads from
    // localStorage and displays progress; it never makes API calls itself.
    const check = () => {
      try {
        const sess = JSON.parse(localStorage.getItem("quantumUploadSession") || "{}");
        const hasProgress = typeof sess?.progress === "number";
        const isCheckedOnce = sess?.checkedOnce === true;

        setQuantumLoading(!!hasProgress && isCheckedOnce);
        if (hasProgress) setQuantumPercent(sess.progress);
      } catch {}
    };

    check();
    const poll = setInterval(check, 300); // 300 ms — smooth 1%-step updates
    return () => clearInterval(poll);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (quantumPercent === 100 && bannerRef.current && !bannerRef.current.contains(event.target)) {
        setQuantumLoading(false);
        try { localStorage.removeItem("quantumUploadSession"); } catch (e) {}
      }
    };
    if (quantumLoading && quantumPercent === 100) {
      document.addEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [quantumLoading, quantumPercent]);

  if (!quantumLoading) return null;

  return (
    // fixed: always visible regardless of scroll position or which page the user is on
    <div ref={bannerRef} className="fixed top-0 left-0 right-0 w-full" style={{ zIndex: 1001 }}>
      <AIReportProgressBanner
        visible={quantumLoading}
        onCancel={() => {
          setQuantumLoading(false);
          try { localStorage.removeItem("quantumUploadSession"); } catch (e) {}
        }}
        onView={(type) => {
          setQuantumLoading(false);
          try { localStorage.removeItem("quantumUploadSession"); } catch (e) {}
          navigate(APP_ROUTES.AI_REPORT, { state: { tab: type || "skin_care" } });
        }}
        percentOverride={quantumPercent}
      />
    </div>
  );
};

export default GlobalAIReportProgressBanner;